import { render, staticRenderFns } from "./swipers.vue?vue&type=template&id=b20f3582&scoped=true"
import script from "./swipers.vue?vue&type=script&lang=js"
export * from "./swipers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20f3582",
  null
  
)

export default component.exports